// Common AAGUIDs - add more as needed
// Source: https://github.com/nicokoenig/fido-aaguid
const AAGUID_REGISTRY: Record<string, string> = {
  'adce0002-35bc-c60a-648b-0b25f1f05503': 'Chrome on Mac',
  'ea9b8d66-4d01-1d21-3ce4-b6b48cb575d4': 'Google Password Manager',
  '08987058-cadc-4b81-b6e1-30de50dcbe96': 'Windows Hello',
  'd548826e-79b4-db40-a3d8-11116f7e8349': 'Bitwarden',
  'b92c3f9a-c014-4056-887f-140a2501163b': 'Security Key by Yubico',
  'ee882879-721c-4913-9775-3dfcce97072a': 'YubiKey 5',
  'fb1d0002-35bc-c60a-648b-0b25f1f05503': 'Chrome on Windows',
  '9ddd1817-af5a-4672-a2b9-3e3dd95000a7': 'Windows Hello',
  '6028b017-b1d4-4c02-b4b3-afcdafc96bb2': 'Windows Hello',
  '39a5647f-1f1c-4663-a940-70f1a87f2fad': 'iCloud Keychain (Passkeys)',
  'dd4ec8da-e01f-4008-844a-e4d4f43a8a5a': 'iCloud Keychain',
  'fbfc3007-154e-4ecc-8c0b-6e020557d7bd': '1Password',
};

export function lookupAaguid(aaguid: string | null): string {
  if (!aaguid) return 'Unknown';
  return AAGUID_REGISTRY[aaguid] || `Unknown (${aaguid.slice(0, 8)}…)`;
}
